import React, { useEffect, useState } from "react";

import { FormGroup, Label, Input } from "reactstrap";
import SchlSearchPop from "./SchlSearchPop";

const StepSchlOptions = (props) => {
    const { myInitInfo, setMyInitInfo } = props;

    const [mySchlsInfo, setMySchlsInfo] = useState({
        schlCd: "",
        schlNm: "",
    });

    useEffect(() => {
        setMySchlsInfo({
            schlCd: myInitInfo.schlCd,
            schlNm: myInitInfo.schlNm,
        });
    }, [myInitInfo]);

    return (
        <FormGroup tag="fieldset">
            <Label className="conlabel">2. 학교 정보를 입력해주세요.</Label>
            <FormGroup check className="d_inb">
                <Input
                    type="radio"
                    name="radio2"
                    id="findSchool1"
                    checked={myInitInfo.schlCdFlag === "Y"}
                    value="Y"
                    onChange={(e) => {
                        setMyInitInfo({
                            ...myInitInfo,
                            schlCdFlag: e.target.value,
                        });
                    }}
                />
                <Label check htmlFor="findSchool1">
                    <span className="icon" />
                    있어요
                </Label>
            </FormGroup>
            <FormGroup check className="d_inb">
                <Input
                    type="radio"
                    name="radio2"
                    id="findSchool2"
                    checked={myInitInfo.schlCdFlag === "N"}
                    value="N"
                    onChange={(e) => {
                        setMyInitInfo({
                            ...myInitInfo,
                            schlCdFlag: e.target.value,
                            schlCd: "",
                            schlNm: "",
                        });
                    }}
                />
                <Label check htmlFor="findSchool2">
                    <span className="icon" />
                    없어요<span className="info">(학교 정보가 없는 경우 선택)</span>
                </Label>
            </FormGroup>
            <div className="find_sch_wrap">
                <SchlSearchPop
                    {...props}
                    mySchlsInfo={mySchlsInfo}
                    myInitInfo={myInitInfo}
                    setMyInitInfo={setMyInitInfo}
                    buttonLabel="학교 찾기"
                    className="find_sch_pop"
                />
            </div>
        </FormGroup>
    );
};
export default StepSchlOptions;
